import {
  ObservabilityToolType,
  TeamExternalIntegrationAuthenticationStatus,
  type TeamExternalIntegrationAzure,
  type TeamExternalIntegration
} from 'types/api/status-checks/status-check'

import type {
  AuthenticationRequestBodyAzure,
  CreateAuthenticationRequestParams
} from 'queries/external-integrations/types'

export function isTeamExternalIntegrationAzure(
  integration: TeamExternalIntegration
): integration is TeamExternalIntegrationAzure {
  const { domain, identifier, observabilityToolType } = integration
  return Boolean(
    domain &&
      identifier &&
      observabilityToolType === ObservabilityToolType.AZURE
  )
}

export function getAzureAuthenticationPayload(
  subscriptionId: string
): [CreateAuthenticationRequestParams, AuthenticationRequestBodyAzure] {
  const observabilityToolType = ObservabilityToolType.AZURE

  return [
    {
      domain: subscriptionId,
      observabilityToolType
    },
    {
      name: observabilityToolType,
      privateNetwork: false,
      lastAuthenticationStatus:
        TeamExternalIntegrationAuthenticationStatus.Authenticated
    }
  ]
}

/**
 * Given a path to an ARM Deployment Template (json), creates a link that Azure
 * uses to consume the template.
 */
export function getAzureMetadataAuthenticationUrlFromResponse(cdnPath: string) {
  return `https://portal.azure.com/#create/Microsoft.Template/uri/${encodeURIComponent(
    cdnPath
  )}`
}
